module.exports = __webpack_public_path__ + "static/media/zayd_arabic_gulf.218a35df.mp3";